export default {
  columnTreeList: [],
  setColumnTreeList (columnTreeList) {
    this.columnTreeList = columnTreeList
  }
}
